const evaluationMessage = {
  getList: 'WeighingEvaluation/getlist',
  update: 'WeighingEvaluation/update',
  add: '',
  getAll: 'WeighingEvaluation/getall'
}

export default evaluationMessage